module.exports = __webpack_public_path__ + "img/abstract4.1ff772d.svg";